import {combineReducers} from '@reduxjs/toolkit';
import authSlice from './auth.slice';
import {toastSlice} from './toasts.slice';

export const rootReducer = combineReducers({
    toasts: toastSlice.reducer,
    auth: authSlice.reducer,
});
